import React from 'react';
import PropTypes from 'prop-types';

import {Box, TextField, Button} from 'views/components';
import {Translate} from 'views/module';
import {Clear} from 'views/icons';

const ContactBox = (props) => {
  const {data, onUpdate, onDelete} = props;

  const handleChange = (field, value) => {
    onUpdate({...data, [field]: value});
  };

  return (
    <Box
      style={{
        background: 'white',
        borderRadius: '1rem',
        boxShadow: '0 1px 6px rgba(0,0,0,0.1)',
        padding: '1rem',
        position: 'relative',
        minHeight: 120,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <TextField
        label={<Translate expression="profile.ContactBox.ContactName" />}
        value={data.name}
        onChange={(e) => handleChange('name', e)}
        fullWidth
        inputProps={{style: {fontSize: 13, height: 32, padding: '4px 8px'}}}
        InputLabelProps={{shrink: true}}
      />
      <TextField
        label={<Translate expression="profile.ContactBox.Relationship" />}
        value={data.relationship}
        onChange={(e) => handleChange('relationship', e)}
        fullWidth
        style={{marginTop: 8}}
        inputProps={{style: {fontSize: 13, height: 32, padding: '4px 8px'}}}
        InputLabelProps={{shrink: true}}
      />
      <TextField
        label={<Translate expression="profile.ContactBox.PhoneNumber" />}
        value={data.phoneNumber}
        onChange={(e) => handleChange('phoneNumber', e)}
        fullWidth
        style={{marginTop: 8}}
        inputProps={{style: {fontSize: 13, height: 32, padding: '4px 8px'}}}
        InputLabelProps={{shrink: true}}
      />
      <TextField
        label={<Translate expression="profile.ContactBox.Email" />}
        value={data.email}
        onChange={(e) => handleChange('email', e)}
        fullWidth
        style={{marginTop: 8}}
        inputProps={{style: {fontSize: 13, height: 32, padding: '4px 8px'}}}
        InputLabelProps={{shrink: true}}
      />
      <Box sx={{display: 'flex', justifyContent: 'flex-start', mt: 1}}>
        <Button
          variant="outlined"
          onClick={onDelete}
          style={{
            borderColor: '#d1d5db',
            color: '#374151',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontWeight: 500,
            borderRadius: 8,
            background: '#fff',
          }}
        >
          <Clear style={{fontSize: 16, marginRight: 4}} />
          <Translate expression="profile.ContactBox.Delete" />
        </Button>
      </Box>
    </Box>
  );
};

ContactBox.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    relationship: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ContactBox;
